import React, { useEffect, useState } from 'react';
import ArrowLeftIcon from '@ingka/ssr-icon/paths/arrow-left';
import ArrowRightIcon from '@ingka/ssr-icon/paths/arrow-right';
import Button from 'ui/Button/Button';
import { useHistory } from 'react-router-dom';
import { ButtonTypeEnum } from 'ui/Button/Button';
import { leaveFromBackButton } from 'ducks/sheets';
import { useIntl } from 'react-intl';
import { useAppDispatch } from 'ducks/hooks';
import useIsRtl from 'hooks/useIsRtl';
import { isIkeaApp, isMobile } from 'utils/platform';
import usePrevious from 'hooks/usePrevious';
import { AppRoutes } from 'routes';
import { appIntegration, getKioskIntegration } from 'utils/integration';
import { useCore } from 'contexts/core';

const BackButton = () => {
  const history = useHistory();
  const previous = usePrevious(history.location.pathname);
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const isRtl = useIsRtl();
  const [previousPage, setPreviousPage] = useState<string>(AppRoutes.PLANNER);
  const kioskIntegration = getKioskIntegration();
  const coreApi = useCore();

  useEffect(() => {
    if (previous && history.location.pathname !== previous && history.action !== 'REPLACE') {
      setPreviousPage(previous);
    }
  }, [history.action, history.location.pathname, previous]);

  const onBackClicked = () => {
    dispatch(leaveFromBackButton(true));

    if (isIkeaApp()) {
      return appIntegration.backClicked();
    }

    coreApi.camera.resetCamera();

    if (
      !previousPage ||
      previousPage === AppRoutes.SUMMARY ||
      previousPage === AppRoutes.PLANNER ||
      previousPage === AppRoutes.PLANNER_NEW
    ) {
      history.push(AppRoutes.LANDING_PAGE);
    } else {
      history.goBack();
    }

    kioskIntegration.backClicked();
  };

  return (
    <Button
      ssrIcon={isRtl ? ArrowRightIcon : ArrowLeftIcon}
      inverseTheme={true}
      dataTestId="back-button"
      onClick={onBackClicked}
      type={ButtonTypeEnum.primary}
      expanding={true}
      aria-label={formatMessage({ id: 'storageone.backButtonLeavePlanner' })}
      text={formatMessage({ id: 'storageone.backButtonLeavePlanner' })}
      size={isMobile() ? 'small' : 'medium'}
      iconOnly
    />
  );
};

export default BackButton;
